import MediaCollection from './MediaCollection';

export default MediaCollection;
